import { gsap} from 'gsap';
import { Helper } from "../../../dev/utils/Helper";
import { MathHelper } from "../../../dev/utils/MathHelper";
import { StageLayer } from "@nolimitcity/slot-launcher/bin/StageLayer";
import { ISequencePlay } from "../../../dev/displayobject/Sequence";
import { SpinePlayConfig } from "../../../dev/displayobject/SpinePlayer";
import { UniversalPlayer, UniPlayer } from "../../../dev/displayobject/UniversalPlayer";
import { IDimOrientation, LayoutDimData, ResizeHelper } from "../../../dev/utils/ResizeHelper";
import { RoadRage } from '../../RoadRage';

export class FeaturePosterState {
    public static readonly POSTER = "Next";
    public static readonly POSTER_JAM = "Next_Highway_Jam";
    public static readonly POSTER_JAM_IDLE = "Next_Highway_Jam_Idle";

    public static readonly POSTER_MAYHEM = "Next_City_Mayhem";
    public static readonly POSTER_MAYHEM_IDLE = "Next_City_Mayhem_Idle";
}

export class NoWinPosterState {
    public static readonly NO_WIN = "No_Win";
    public static readonly EXPIRED = "NW_Expired";
    public static readonly FLAT_TIRE = "NW_Flat_Tire";
    public static readonly LOW_GAS = "NW_Low_Gas";
}

export class BigWinPosterState {
    // public static readonly BIG_WIN:string[] = ArrayHelper.initArrayWithValues(5,(i) => ("Big_Win/BW_Placeholder_" + (i+1)));

    public static readonly BIG_WIN:string = "Big_Win";

    // public isBigwinState(state:string):boolean{

    // }

    // public static bigWinTypeLvl(lvl:number):string{
    //     return this.BIG_WIN[Math.min(lvl,this.BIG_WIN.length-1)]
    // }

    public static bigWinLvl(lvl:number):number{
        return Math.min(lvl+1,5);
    }

    public static bigWinTypeLvl(lvl:number):string{
        if(RoadRage.apiPlugin.gameClientConfiguration.useCensoredGfxUS){
            if(this.bigWinLvl(lvl) == 1){
                return "Big_Win_1_WV"
            }
            if(this.bigWinLvl(lvl) == 2){
                return "Big_Win_2_WV"
            }
        }

        return this.BIG_WIN + "_" + this.bigWinLvl(lvl);
    }
    public static bigWinTypeIntroLvl(lvl:number):string{

        if(RoadRage.apiPlugin.gameClientConfiguration.useCensoredGfxUS){
            if(this.bigWinLvl(lvl) == 1){
                return "Big_Win_1_WV__Intro"
            }
            if(this.bigWinLvl(lvl) == 2){
                return "Big_Win_2_WV_Intro"
            }
        }


        return this.BIG_WIN + "_" + this.bigWinLvl(lvl) +"_Intro";
    }
}

export class PosterManager extends PIXI.Container implements StageLayer {

    public get dim():LayoutDimData{ return ResizeHelper.calcDim(this.PosterDim); };

    private PosterDim:IDimOrientation = {
        landscape :{
            scale:      new PIXI.Point( 1, 1),
            position:   new PIXI.Point( 360, 360),
        },
        portrait :{
            scale:      new PIXI.Point( 1, 1),
            position:   new PIXI.Point( 360, 220)
        }
    };

    private WIDTH:number = 1440;
    private HEIGHT:number = 900;

    private static _instance:PosterManager;
    private player:UniversalPlayer;
    private postObj:UniPlayer;
    
    private blackGraphics:PIXI.Graphics;

    private gradientOverlay:PIXI.Sprite;
    private gradientSupported:boolean = true;

    private timeline:gsap.core.Timeline | undefined;
    private timelineBlack:gsap.core.Timeline;

    private nextPosterAnim:string = "";

    public static get instance():PosterManager{
        return this._instance;
    }

    constructor(){
        super();
        PosterManager._instance = this;
        this.name = "PosterManager";
        this.initAnimations();
    };

    public gradientColorLvl(lvl:number):string{
        switch(lvl){
            case 1:
                return "rgb(9,141,55,0.6)";
            case 2:
                return "rgb(0,133,148,0.6)";
            case 3:
                return "rgb(7,41,139,0.6)";
            case 4:
                return "rgb(142,8,133,0.6)";
            case 5:
                return "rgb(141,7,14,0.6)";
            default:
                return "rgb(0,0,0,0.6)"
        }
    }

    protected initAnimations():void{

        this.createGraphics();
        try{
            this.gradientOverlay = this.addChild(new PIXI.Sprite(this.createGradTexture(this.gradientColorLvl(0))));
            this.gradientOverlay.anchor.set(0.5,0.5);
            this.gradientOverlay.rotation = MathHelper.degreeToAngle(90);
            this.gradientOverlay.alpha = 0;
            this.gradientSupported = false;
        }
        catch{
            this.gradientSupported = false;
        }

        // Random_Intro
        this.player = new UniversalPlayer([
            FeaturePosterState.POSTER,
            BigWinPosterState.BIG_WIN,
            "Random_Intro"
        ]);

        this.player.uniPlayers.forEach(p => {
            this.addChild(p.obj);
            p.obj.alpha = 0;
        });

        this.onResize();
    }

    public introPlay():void{
        if(this.gradientSupported){
            this.gradientOverlay.texture = this.createGradTexture(this.gradientColorLvl(10));
            gsap.fromTo(this.gradientOverlay, { alpha:1 }, { alpha:0,duration:0.5 });
        } 
    }

    protected createGradTexture(color:string):PIXI.Texture {
        // adjust it if somehow you need better quality for very very big images
        const quality = 126;
        const canvas = document.createElement('canvas');
        canvas.width = quality;
        canvas.height = 1;
    
        const ctx = canvas.getContext('2d');
    
        // use canvas2d API to create gradient
        const grd = ctx!.createLinearGradient(0, 0, quality, 0);
        grd.addColorStop(0, color);
        grd.addColorStop(0.75, 'black');
    
        ctx!.fillStyle = grd;
        ctx!.fillRect(0, 0, quality, 1);
    
        return PIXI.Texture.from(canvas);
    }

    public play(state:string, conf?:ISequencePlay | SpinePlayConfig, fadeIn?:number,gradientLvl?:number):gsap.core.Timeline{

        this.timeline = Helper.setTimeline(this.timeline);
        this.postObj = this.player.get(state);

        this.timeline.add(this.postObj.play(conf));

        if(state === FeaturePosterState.POSTER){
            this.postObj.obj.scale.set(1)
            this.postObj.obj.position.set(0);
            this.nextPosterAnim = (conf as SpinePlayConfig).animation;
        } 

        if(state === BigWinPosterState.BIG_WIN && this.gradientSupported){
            this.gradientOverlay.texture = this.createGradTexture(this.gradientColorLvl(BigWinPosterState.bigWinLvl(gradientLvl ? gradientLvl : 0)));

            if(fadeIn != undefined)
                this.timeline.fromTo(this.gradientOverlay,{alpha:0}, {duration:fadeIn, alpha:1},0)
            else
                this.gradientOverlay.alpha = 1;
        }else{
            if(fadeIn != undefined)
                this.timeline.fromTo(this.blackGraphics,{alpha:0},{duration:fadeIn, alpha:0.4},0)
            else
                this.blackGraphics.alpha = 0.4;
        }

        if(fadeIn != undefined)
            this.timeline.fromTo(this.postObj.obj,{alpha:0}, {duration:fadeIn, alpha:1},0)
        else 
            this.postObj.obj.alpha = 1;

        return this.timeline;
    }

    private signShown:boolean = false;
    public moveDown(isMorgon:boolean):gsap.core.Timeline{
        this.timeline = Helper.setTimeline(this.timeline,new gsap.core.Timeline({onComplete:() => {
            this.postObj.play({ animation: this.nextPosterAnim === FeaturePosterState.POSTER_JAM ?  FeaturePosterState.POSTER_JAM_IDLE : FeaturePosterState.POSTER_MAYHEM_IDLE, loop:true, showOnEnd:true })
            this.postObj = undefined!;
        }}));

        const scaleTo:number = isMorgon ? 0.8 : 0.62;
        this.timeline.to(this.postObj.obj,{y: (isMorgon ? 260 : 305) + (ResizeHelper.isLandscape ? 0 : 140),duration:0.5},0)
        this.timeline.to(this.postObj.obj.scale,{y: scaleTo, x: scaleTo, duration:0.5},0)
        this.timeline.to(this.blackGraphics,{duration:0.5,alpha:0},0)
        this.signShown = true;

        return this.timeline;
    }

    public restoreShow(isMorgon:boolean,isHighWay:boolean):void{
        this.signShown = true;
        this.postObj = this.player.get(FeaturePosterState.POSTER);
        this.postObj.play({ animation: isHighWay ?  FeaturePosterState.POSTER_JAM_IDLE : FeaturePosterState.POSTER_MAYHEM_IDLE, loop:true, showOnEnd:true });
        const scaleTo:number = isMorgon ? 0.8 : 0.62;

        this.postObj.obj.scale.set(scaleTo);
        this.postObj.obj.position.set(0, (isMorgon ? 260 : 305) + (ResizeHelper.isLandscape ? 0 : 140));
        this.postObj.obj.alpha = 1;
        this.postObj.obj.visible = true;

        this.postObj = undefined!;
    }

    public hideSign(): void {
        Helper.setTimeline().to(this.player.get(FeaturePosterState.POSTER).obj, { alpha: 0, duration: 0.25 });
    }

    public stop(fadeout:number = 0.2,playEnd?:boolean):gsap.core.Timeline{
        if(!this.postObj) return Helper.setTimeline()
        this.timeline = Helper.setTimeline(this.timeline, new gsap.core.Timeline({
            onUpdate:() => {
                if(this.postObj.obj)
                    this.postObj.obj.alpha = 1-this.timeline!.progress();
            },
            onComplete:() => {
                this.postObj.stop(playEnd);
                if(this.postObj.obj)
                    this.postObj.obj.alpha = 0;
            }
        }));

        if(this.gradientSupported && this.gradientOverlay.alpha > 0) this.timeline.to(this.gradientOverlay, {duration:fadeout, alpha:0},0)
        this.timeline.to(this.blackGraphics,{duration:fadeout,alpha:0},0)
        
        return this.timeline;
    }

    public setBlackScreenAlpha(to:number,duration:number = 0.3):gsap.core.Timeline{
        this.timelineBlack = Helper.setTimeline(this.timelineBlack,new gsap.core.Timeline());
        this.timelineBlack.to(this.blackGraphics,{duration:duration,alpha:to});
        return this.timelineBlack;
    }

    private createGraphics():void{
        this.blackGraphics = new PIXI.Graphics();
        this.blackGraphics.alpha = 0;
        this.blackGraphics.interactive = false;
        this.blackGraphics.buttonMode = false;

        this.blackGraphics.beginFill( 0x000000, 1);
        this.blackGraphics.drawRect(-this.WIDTH,-this.HEIGHT,this.WIDTH*2, this.HEIGHT*2);
        this.blackGraphics.endFill();

        this.addChild(this.blackGraphics);
    }

    onResize(){
        if(this.blackGraphics === undefined) return;

        if(this.gradientSupported && this.gradientOverlay){
            this.gradientOverlay.width = ResizeHelper.resizeData.height;
            this.gradientOverlay.height = ResizeHelper.resizeData.width;            
            this.gradientOverlay.position.y = 360 - this.dim.position.y;
        }

        this.position = this.dim.position;
        this.scale = this.dim.scale;

        if(this.signShown){
            const obj = this.player.get(FeaturePosterState.POSTER).obj;
            if(!ResizeHelper.isLandscape && obj.position.y <= 310){
                obj.position.y += 140;
            }else if(ResizeHelper.isLandscape && obj.position.y >= 310){
                obj.position.y -= 140;
            }
        }
    }
}